document.getElementById("tracking-btn").addEventListener("click", async () => {

  const order = document.getElementById("tracking-order").value
  const email = document.getElementById("tracking-email").value

  if(!order || !email){
    alert("Please enter order number and email")
    return
  }

  const btn = document.getElementById("tracking-btn")
  btn.innerText = "Checking..."

  try{

    const res = await fetch(`https://enzoleo.vn/shopify/tracking?order_number=${order}&email=${email}`,{
    })

    const data = await res.json()

    renderStatus(data.invoice.invoiceDelivery.statusValue)

  }catch(err){
    console.log(err)
    alert("Cannot check order status")
  }

  btn.innerText = "Track Order"

})


function renderStatus(currentStatus){

  const statuses = [
    "Chờ xử lý",
    "Đang lấy hàng",
    "Chờ lấy lại",
    "Đã lấy hàng",
    "Đang giao hàng",
    "Chờ giao lại",
    "Đã giao hàng"
  ]

  const container = document.getElementById("tracking-status")

  container.innerHTML = ""

  statuses.forEach(status => {

    const div = document.createElement("div")

    div.className = "timeline-item"

    if(status === currentStatus){
      div.classList.add("active")
    }

    div.innerHTML = `
      <div class="timeline-dot"></div>
      <div class="timeline-text">${status}</div>
    `

    container.appendChild(div)

  })

  document.getElementById("tracking-result").classList.remove("hidden")

}